import { PrimaryButton, TextButton } from "_components/atoms/button";
import Typography                    from "_components/atoms/typography";
import VideoCard                     from "_components/organisms/videoCardList/videoCard";

import useStyles from "./styles";

const component = props => {
	const {
		isVideoEnded,
		nextVideoItem,
		timeLeft,
		cancelClickHandler,
		playNowClickHandler
	} = props;

	const { classes } = useStyles ( { isVideoEnded } );

	if ( !isVideoEnded || !nextVideoItem )
		return null;

	return (
		<div className = { classes.multiMediaContainer }>
			<Typography className = { classes.timeLeft }
				title                = { `Next Video in ${ timeLeft ?? 0 }` }
			/>

			<VideoCard
				hideMenuOptions
				customClasses      = { { bottomDetailsTitle: classes.bottomDetailsTitleClass } }
				data               = { nextVideoItem }
				isWithoutAnimation = { true }
			/>

			<div className = { classes.buttonContainer }>
				<TextButton
					buttonTextClassName = { classes.cancelText }
					className           = { classes.cancelButton }
					label               = { "Cancel" }
					onClick             = { cancelClickHandler }
					size                = "small"
				/>

				<PrimaryButton
					onClick = { playNowClickHandler }
					size    = "small"
					title   = "Play Now"
				/>
			</div>
		</div>
	);
};

export default component;
